import React from "react";

export const Tag = ({ children, c, isDark }) => (
  <span style={{
    background: isDark ? "rgba(46,52,71,0.4)" : "rgba(220,226,255,0.6)",
    color: c.onSurfaceVariant,
    padding: "4px 12px", borderRadius: 9999,
    fontSize: 12, fontFamily: "'JetBrains Mono', monospace",
    letterSpacing: "0.05em", fontWeight: 500,
    border: `1px solid ${isDark ? "rgba(66,71,84,0.4)" : "rgba(0,0,0,0.08)"}`,
  }}>
    {children}
  </span>
);